'use client';

import ErrorBoundary from '@/components/common/ErrorBoundary';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: ErrorProps) {
  return (
    <ErrorBoundary
      error={error}
      reset={reset}
      context="global"
      dashboardUrl="/"
      errorContext="グローバル"
      backButtonText="トップページに戻る"
    />
  );
}
